(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  const play = (element, frames, options) => {
    if (reduced.matches || !element.animate) return;
    const animation = element.animate(frames, options);
    running.add(animation);
    animation.finished.then(() => running.delete(animation), () => running.delete(animation));
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      observer.unobserve(entry.target);
      play(entry.target, [{ opacity: .25, transform: 'translateY(24px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 850, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
  }, { threshold: .12 }) : null;
  const init = (root = document) => {
    root.querySelectorAll('[data-jt-reveal]').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (!reduced.matches && !window.Shopify?.designMode) observer?.observe(element);
    });
    root.querySelectorAll('.jt-hero__content').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      play(element, [{ opacity: .25, transform: 'translateY(20px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 1100, easing: 'cubic-bezier(.22,1,.36,1)' });
    });
  };
  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      observer?.disconnect();
      running.forEach(animation => animation.finish());
    }
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-jt-reveal]').forEach(element => observer?.unobserve(element)));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
